import { messageFromJSON, messageToJSON, newBroadcastMessage,
         newErrorMessage, MESSAGE_TYPE } from '../../models/message'

const state = {
  // Current username
  user: '',

  // Room name
  room: '',

  // Link to backend
  service: '',

  // Websocket instance
  socket: null,

  // Is webscoket tonnected to backend
  connected: false,

  // Is websocket connecting now
  connecting: false,

  // Text of login error
  loginErrorText: '',

  // Current messages
  messages: [],

  // Size of message queue
  maxMessagesCount: 0,

  // Max length of a message
  maxMessageLength: 0,

  // Min time between messages, default 0 seconds
  timeBetweenMessages: 0,

  // Max length of sequence of equal messages
  maxEqualMessages: 0,

  // Time of the last sent message
  lastMessageTime: 0,

  // Last message
  lastMessage: '',

  // Count of equal messages
  equalMessages: 0
}

const getters = {
  user: state => state.user,
  room: state => state.room,
  service: state => state.service,

  connected: state => state.connected,
  connecting: state => state.connecting,
  loginErrorText: state => state.loginErrorText,

  messages: state => state.messages,
  maxMessageLength: state => state.maxMessageLength,
  timeBetweenMessages: state => state.timeBetweenMessages,
  maxEqualMessages: state => state.maxEqualMessages
}

const actions = {
  connect ({ state, commit, getters }, { user }) {
    commit('setConnecting')

    let socket = new WebSocket(`${state.service}?user=${user}&room=${state.room}`)
    socket.onopen = function () {
      commit('setSocket', { socket })
    }

    socket.onerror = function () {
      commit('closeSocket')
    }

    socket.onclose = function (event) {
      commit('closeSocket')
    }

    socket.onmessage = function (event) {
      const message = messageFromJSON(event.data)

      switch (message.type) {
        case MESSAGE_TYPE.LOGIN_SUCCESS:
          commit('setConnected')
          commit('setUser', { user })
          break
        case MESSAGE_TYPE.LOGIN_ERROR:
          commit('setLoginErrorText', { error: [getters.backendErrorText(message.data.text)] })
          commit('closeSocket')
          break
        case MESSAGE_TYPE.BROADCAST:
        case MESSAGE_TYPE.ERROR:
          commit('addMessage', { message })
          break
      }
    }
  },

  disconnect ({ state, commit }) {
    state.socket.close()
  },

  sendMessage ({ state, commit, dispatch }, { text }) {
    // Check if the last message was sent recently
    if (((new Date() - state.lastMessageTime) / 1000) < state.timeBetweenMessages) {
      // Error text should be the same as on backend
      const message = newErrorMessage('you are sending messages too quickly')
      commit('addMessage', { message })
      return
    }

    const message = newBroadcastMessage({
      text: text,
      usernameColor: this.getters.usernameColor.hex
    })

    // Check if the last message equals new message
    let equalMessages = 0
    if (state.lastMessage === message.data.text) {
      equalMessages = state.equalMessages + 1
    }
    if (equalMessages > state.maxEqualMessages) {
      // Error text should be the same as on backend
      const message = newErrorMessage('you are sending equal messages')
      commit('addMessage', { message })
      return
    }

    try {
      state.socket.send(messageToJSON(message))
      commit('setLastMessageTime', { time: new Date() })

      if (state.lastMessage !== message.data.text) {
        commit('setLastMessage', { message: message.data.text })
        commit('setEqualMessages', { count: 0 })
      }
      commit('setEqualMessages', { count: state.equalMessages + 1 })
    } catch (err) {
      commit('closeSocket')
    }
  }
}

const mutations = {
  setUser (state, { user }) {
    state.user = user
  },

  setRoom (state, { room }) {
    state.room = room
  },

  setService (state, { service }) {
    state.service = service
  },

  setSocket (state, { socket }) {
    state.socket = socket
  },

  closeSocket (state) {
    state.socket = null
    state.connected = false
    state.connecting = false
    state.messages = []
    state.user = ''
  },

  setConnecting (state) {
    state.connecting = true
  },

  setConnected (state) {
    state.connecting = false
    state.connected = true
    state.loginErrorText = ''
  },

  clearLoginErrorText (state) {
    state.loginErrorText = ''
  },

  setLoginErrorText (state, { error }) {
    state.loginErrorText = error
  },

  addMessage (state, { message }) {
    state.messages.push(message)

    if (state.messages.length > state.maxMessagesCount) {
      state.messages.shift()
    }
  },

  clearMessages (state) {
    state.messages = []
  },

  clearErrorMessages (state) {
    state.messages = state.messages.filter(message => message.type !== MESSAGE_TYPE.ERROR)
  },

  setMaxMessageLength (state, { maxMessageLength }) {
    state.maxMessageLength = maxMessageLength
  },

  setMaxMessagesCount (state, { maxMessagesCount }) {
    state.maxMessagesCount = maxMessagesCount
  },

  setTimeBetweenMessages (state, { timeBetweenMessages }) {
    state.timeBetweenMessages = timeBetweenMessages
  },

  setLastMessageTime (state, { time }) {
    state.lastMessageTime = time
  },

  setMaxEqualMessages (state, { maxEqualMessages }) {
    state.maxEqualMessages = maxEqualMessages
  },

  setLastMessage (state, { message }) {
    state.lastMessage = message
  },

  setEqualMessages (state, { count }) {
    state.equalMessages = count
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/core.js